module.exports = __webpack_public_path__ + "static/img/sn_log.8264834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sn_log.png
// module id = ySJ1
// module chunks = 0